import React from "react";

function BasicModalTickets(props) {
  return (
    <div
      className="modal fade"
      id={props.status}
      tabIndex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-edit" role="document">
        <div className="modal-content" style={{ height: "100vh" }}>
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLongTitle">
              {props.text}
            </h5>
            <button
              type="button"
              id={props.close}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            className="modal-body"
            style={{ height: "100vh", overflow: "auto" }}
          >
            {props.children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BasicModalTickets
